<template>
  <b-card no-body class="summary-card">
    <b-card-body>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <h5 class="mb-0">Your progress</h5>
        <span class="hero-chip" :class="statusClass">
          <feather-icon :icon="statusIcon" size="14" class="mr-25" />
          {{ statusLabel }}
        </span>
      </div>

      <div class="summary-progress mb-1">
        <div class="d-flex justify-content-between small mb-25">
          <span>Sections signed</span>
          <strong>{{ sectionsSigned }} / {{ sectionsTotal }}</strong>
        </div>
        <b-progress :value="sectionsSigned" :max="sectionsTotal || 1" height="6px" variant="success" />
      </div>

      <div v-if="summary && summary.total" class="summary-counts mb-1">
        <div class="summary-count">
          <span class="count text-warning">{{ summary.outstanding || 0 }}</span>
          <span class="label">Outstanding</span>
        </div>
        <div class="summary-count">
          <span class="count text-info">{{ summary.submitted || 0 }}</span>
          <span class="label">Submitted</span>
        </div>
        <div class="summary-count">
          <span class="count text-success">{{ summary.approved || 0 }}</span>
          <span class="label">Approved</span>
        </div>
        <div class="summary-count">
          <span class="count text-danger">{{ summary.rejected || 0 }}</span>
          <span class="label">Rejected</span>
        </div>
      </div>
      <p v-else class="text-muted small mb-1">No documents are required at the moment.</p>

      <small v-if="summary && summary.openRequests" class="text-muted d-block mb-1">
        <feather-icon icon="MessageSquareIcon" size="12" class="mr-25" />
        {{ summary.openRequests }} open request(s) to Swiss Finance
      </small>

      <h6 class="mt-0">Steps</h6>
      <ul class="summary-steps">
        <li
          v-for="(step, index) in steps"
          :key="step.key"
          :class="['summary-step', 'step-' + step.state, { 'is-active': index === activeIndex, 'is-clickable': index <= maxStep }]"
          @click="index <= maxStep && $emit('go', index)"
        >
          <feather-icon :icon="stepIcon(step, index)" size="14" class="step-icon" />
          <span class="step-title">{{ step.title }}</span>
          <small v-if="step.state === 'signed'" class="text-muted ml-auto">signed</small>
          <small v-else-if="step.state === 'new'" class="text-warning ml-auto">new</small>
        </li>
      </ul>
    </b-card-body>
  </b-card>
</template>

<script>
// Progress card next to the wizard: status chip, sections signed/total, requirement
// counts and a clickable list of the wizard steps.
export default {
  name: "OnboardingSummaryCard",

  props: {
    summary: { type: Object, default: null },
    status: { type: String, default: "Draft" },
    // [{key, title, state: 'signed'|'new'|'done'|'pending'|'locked'}]
    steps: { type: Array, default: () => [] },
    activeIndex: { type: Number, default: 0 },
    maxStep: { type: Number, default: 0 },
  },

  computed: {
    sectionsTotal() {
      return (this.summary && this.summary.sectionsTotal) || 0;
    },
    sectionsSigned() {
      return (this.summary && this.summary.sectionsSigned) || 0;
    },
    statusLabel() {
      return (
        {
          Draft: "Draft",
          InProgress: "In progress",
          Signed: "Signed",
          Reopened: "Reopened",
          Complete: "Complete",
        }[this.status] || this.status || "Draft"
      );
    },
    statusClass() {
      return (
        {
          Draft: "chip-pending",
          InProgress: "chip-pending",
          Signed: "chip-success",
          Reopened: "chip-warning",
          Complete: "chip-success",
        }[this.status] || "chip-pending"
      );
    },
    statusIcon() {
      return (
        {
          Draft: "Edit3Icon",
          InProgress: "Edit3Icon",
          Signed: "CheckCircleIcon",
          Reopened: "RefreshCwIcon",
          Complete: "AwardIcon",
        }[this.status] || "Edit3Icon"
      );
    },
  },

  methods: {
    stepIcon(step, index) {
      if (step.state === "signed" || step.state === "done") return "CheckCircleIcon";
      if (step.state === "locked") return "LockIcon";
      if (index === this.activeIndex) return "ArrowRightCircleIcon";
      return "CircleIcon";
    },
  },
};
</script>
